import { EXTERNAL_API_TYPE, PROFILE_TYPE, PROFILE_NAMES } from '../../constants';

export const actions = {
    async getUserData({ commit, dispatch }) {
        const loadedUser = await dispatch('useApiData', {
            name: 'MobileGetByUsername'
        });

        loadedUser.data.maxFeatures = loadedUser.data.organizationMaxFeatures;
        delete loadedUser.data.organizationMaxFeatures;

        loadedUser.data.maxAdressenStuf = loadedUser.data.organizationMaxAdressenStuf;
        loadedUser.data.maxAdressenKvk = loadedUser.data.organizationMaxAdressenKvk || 100;
        delete loadedUser.data.organizationMaxAdressenStuf;
        delete loadedUser.data.organizationMaxAdressenKvk;

        commit('SET_USERDATA', loadedUser.data);
    },

    // Get and store profile names that a user needs to have to allow certain parts of the software
    // First profile to check for is NedBRK
    async getUserProfiles({ commit, dispatch }) {
        const hasNedBRK = await dispatch('useApiData', {
            name: 'GetHasProfileName',
            data: {
                'profileName': PROFILE_NAMES.NedBRK,
                'profileType': PROFILE_TYPE.THEME_FEEDBACK
            }
        });
        commit('SET_USER_IS_NEDBRK_AUTHORIZED', hasNedBRK.data);
    },

    async getUserThemeGroups({ commit, dispatch }) {
        const loadedUserThemeProfiles = await dispatch('useApiData', { name: 'GetUserThemeProfiles' });
        commit('SET_USERDATA', { themeProfiles: loadedUserThemeProfiles.data });
    },

    // Determines whether any Api is licensed for this organization
    async getHasAnyApiLicense({ commit, dispatch }) {
        const hasAnyApiLicens = await dispatch('useApiData', {
            name: 'GetHasAnyApiLicense'
        });
        commit('SET_HAS_ANY_API_LICENSE', hasAnyApiLicens.data);
    },

    async getUserApis({ commit, dispatch }) {
        const loadedUserApis = await dispatch('useApiData', { name: 'GetUserApis' });
        commit('SET_USERDATA', { apis: loadedUserApis.data });
        if (loadedUserApis.data.length) {
            commit('SET_HAS_ANY_API_LICENSE', true);
            if (loadedUserApis.data.find(api => api.apiType === EXTERNAL_API_TYPE.BRK)) {
                commit('SET_USER_IS_BRK_AUTHORIZED', true);
            }
            if (loadedUserApis.data.find(api => api.apiType === EXTERNAL_API_TYPE.BRP)) {
                commit('SET_USER_IS_BRP_AUTHORIZED', true);
            }
            if (loadedUserApis.data.find(api => api.apiType === EXTERNAL_API_TYPE.WOZ)) {
                commit('SET_USER_IS_WOZ_AUTHORIZED', true);
            }
            // For stuff API store the stuf authorization
            // plus if the user is allowed to execute Stuf person queries
            const stufApis = loadedUserApis.data.filter(api => api.apiType === EXTERNAL_API_TYPE.STUFF);

            if (stufApis?.length > 0) {
                commit('SET_USER_IS_STUF_AUTHORIZED', true);
            }
            const isAllowedStufPersonQueries = stufApis.find(api => api.allowStufPersonQueries);

            if (isAllowedStufPersonQueries) {
                commit('SET_USER_IS_ALLOWED_STUF_PERSON_QUERIES', true);
            }

            if (loadedUserApis.data.find(api => api.apiType === EXTERNAL_API_TYPE.KVK)) {
                commit('SET_USER_IS_KVK_AUTHORIZED', true);
            }
            if (loadedUserApis.data.find(api => api.apiType === EXTERNAL_API_TYPE.ENERGYLABEL)) {
                commit('SET_USER_IS_ENERGYLABEL_AUTHORIZED', true);
            }
        }
    }
};
